export type PlantafelMembershipRole = 'owner' | 'admin' | 'member';

export type PlantafelEmployeeSortable = {
  name: string;
  membership_role?: PlantafelMembershipRole | null;
};

/** Lower rank = higher in the list. Owners first, then admins, then everyone else. */
export function plantafelMembershipRoleRank(role: PlantafelMembershipRole | null | undefined): number {
  if (role === 'owner') return 0;
  if (role === 'admin') return 1;
  return 2;
}

export function comparePlantafelEmployees(
  a: PlantafelEmployeeSortable,
  b: PlantafelEmployeeSortable,
): number {
  const roleDiff =
    plantafelMembershipRoleRank(a.membership_role) - plantafelMembershipRoleRank(b.membership_role);
  if (roleDiff !== 0) return roleDiff;
  return a.name.localeCompare(b.name, 'de');
}

export function sortPlantafelEmployees<T extends PlantafelEmployeeSortable>(employees: T[]): T[] {
  return [...employees].sort(comparePlantafelEmployees);
}
